import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const getMasterPermissionList = (tokens: any, reqBody: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getMasterPermissionList,
    method: 'GET',
    cache: false,
    body: reqBody,
  }
  return executeRequest(request).then(({ data }) => {
    console.log('executeRequest', data)
    return data?.permissionDetails
  })
}

export { getMasterPermissionList }
